import React from 'react'
import PropTypes from 'prop-types'
import './Characters.styles.css'

function SealIcon({ filled = false, size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="currentColor">
      {filled ? (
        <path d="M12.1 21.35l-1.1-1.02C5.14 14.88 2 12.03 2 8.5 2 6 4 4 6.5 4c1.54 0 3.04.81 3.9 2.09C11.46 4.81 12.96 4 14.5 4 17 4 19 6 19 8.5c0 3.53-3.14 6.38-8.01 11.83l-.89 1.02z" />
      ) : (
        <path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.57 3.4 6.64 8.55 11.54L12 21.35l1.45-1.32C18.6 15.14 22 12.07 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 13.24 4 10.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5 18.5 5 20 6.5 20 8.5c0 1.89-3.14 4.74-7.9 10.05z" />
      )}
    </svg>
  )
}

export default function CharacterCard({
  id,
  slug,
  name,
  clan,
  rank,
  level,
  main,
  academyMode,
  imageUrl,
  publicMode = false,
  onToggleMain,
  onClick,
}) {
  const clanLabel = String(clan || '').trim()
  const displayName = !publicMode && clanLabel ? `${clanLabel} ${name}` : name
  const metaParts = []
  if (publicMode) {
    if (academyMode) metaParts.push('Estudiante de academia')
  } else {
    if (level != null && level !== '') metaParts.push(`Nv. ${level}`)
    if (rank) metaParts.push(String(rank))
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      onClick?.(slug)
    }
  }

  const handleFavoriteClick = (e) => {
    e.stopPropagation()
    onToggleMain?.(id, !main)
  }

  const handleImgError = (e) => {
    e.currentTarget.src = '/assets/images/shuriken.png'
  }

  return (
    <div
      className={`characterCard ${main ? 'mainHighlight' : ''} ${publicMode ? 'characterCard--public' : ''}`}
      role="button"
      tabIndex={0}
      onClick={() => onClick?.(slug)}
      onKeyDown={handleKeyDown}
      aria-label={displayName}
    >
      <img
        className="characterImage"
        loading="lazy"
        src={imageUrl}
        alt=""
        onError={handleImgError}
      />

      {!publicMode && typeof onToggleMain === 'function' ? (
        <div className="overlayTop">
          <button
            type="button"
            className="favoriteBtn"
            onClick={handleFavoriteClick}
            aria-pressed={!!main}
            aria-label={main ? 'Quitar principal' : 'Marcar como principal'}
            title={main ? 'Quitar principal' : 'Marcar como principal'}
          >
            <SealIcon filled={!!main} />
          </button>
        </div>
      ) : null}

      <div className="overlayBottom">
        <div className="charName">{displayName}</div>
        <div className="charMeta">
          {metaParts.join(' · ') || (!publicMode ? clanLabel || '—' : '—')}
        </div>
      </div>
    </div>
  )
}

CharacterCard.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  slug: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  clan: PropTypes.string,
  rank: PropTypes.string,
  level: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  main: PropTypes.bool,
  academyMode: PropTypes.bool,
  imageUrl: PropTypes.string.isRequired,
  publicMode: PropTypes.bool,
  onToggleMain: PropTypes.func,
  onClick: PropTypes.func.isRequired,
}

SealIcon.propTypes = {
  filled: PropTypes.bool,
  size: PropTypes.number,
}
